import { render, staticRenderFns } from "./SwEmail.vue?vue&type=template&id=1abb7649"
import script from "./SwEmail.vue?vue&type=script&lang=js"
export * from "./SwEmail.vue?vue&type=script&lang=js"
import style0 from "./SwEmail.vue?vue&type=style&index=0&id=1abb7649&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports